import { Component, inject, OnInit } from '@angular/core'
import { Router, RouterOutlet } from '@angular/router'
import { Store } from '@ngrx/store'
import { SimpleNotificationsModule } from 'angular2-notifications'
import type { KeycloakProfile } from 'keycloak-js'
import { catchError, filter, from, of, Subscription, tap } from 'rxjs'
import packageInfo from '../../package.json'
import { AppSpinnerService } from './shared/components/app-spinner/app-spinner.service'
import { AuthenticationService } from './shared/services/authentication.service'
import { ConfigService } from './shared/services/config.service'
import { LogService } from './shared/services/log.service'
import { getPNOUserNotifications, setSectors, setSoughtPartnerCountries, setUser } from './shared/store/stage/stage.actions'
import { getSectors } from './shared/store/stage/stage.selectors'
@Component({
   selector: 'app-root',
   standalone: true,
   imports: [RouterOutlet, SimpleNotificationsModule],
   templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
   private _cn = this.constructor.name
   private _store = inject(Store)
   private _router = inject(Router)
   private _configService = inject(ConfigService)
   private _authService = inject(AuthenticationService)
   private _spinnerService = inject(AppSpinnerService)

   private sub = new Subscription()

   constructor(private _logService: LogService) {
      this._logService.packageName = packageInfo.name
      this._logService.packageVersion = packageInfo.version
      this._logService.enableLog = this._configService.environment != 'prod'
   }

   ngOnInit(): void {
      const mn = this.ngOnInit.name

      this._authService.hasLicence().then((hasLicence) => {
         if (hasLicence) {
            this.setUser()
            this._store.dispatch(setSectors())
            this._store.dispatch(setSoughtPartnerCountries())
            this._store.dispatch(getPNOUserNotifications())
         } else {
            this.accessDenied()
         }
      })

      this.sub.add(
         this._authService.licenceSubject$.subscribe((hasLicence) => {
            if (!hasLicence) {
               if (!this._router.url.includes('access-denied')) {
                  this.accessDenied()
               }
            } else if (this._router.url.includes('access-denied')) {
               window.location.reload()
            }
         })
      )
   }

   ngOnDestroy(): void {
      this.sub.unsubscribe()
   }

   private setUser() {
      const mn = this.setUser.name
      from(this._authService.keycloakAngular.loadUserProfile())
         .pipe(
            filter((res) => res != null && res != undefined),
            tap((res) => this._logService.debug(this._cn, mn, 'Keycloack User profile res:', res)),
            catchError((error) => {
               this._logService.error(this._cn, mn, 'Cannot retrive user info...')
               return of(error)
            })
         )
         .subscribe((user: KeycloakProfile) => {
            this._store.dispatch(setUser({ user: { name: `${user.firstName} ${user.lastName}`, email: user.email } }))
         })
   }

   private accessDenied() {
      const mn = this.accessDenied.name
      this._logService.error(this._cn, mn, 'user does not have licence...')
      this._router.navigate(['/access-denied'])
   }
}
